import axios from 'axios';
import { writable } from 'svelte/store';

/** Marker z backendu: PermissionGuard::MARKER_ACCOUNT_BLOCKED (can_read = false). */
export const accountBlockedMarker = 'account_blocked';

/** Klucz i18n komunikatu pełnoekranowego. */
export const accountBlockedMessage =
    'Your account has been blocked. Contact your administrator to restore access.';

/** Ustawiane przez interceptor axiosa; App.svelte zamienia wtedy cały interfejs na komunikat. */
export const accountBlocked = writable<boolean>(false);

/**
 * Czy odpowiedź to odmowa z powodu zablokowanego konta.
 *
 * Wymagamy statusu 403 i markera `account_blocked`, więc pozostałe odmowy (w tym `read_only`)
 * nie wyzwalają ekranu blokady. Markera szukamy w TEKŚCIE odpowiedzi: przy odmowach z metod
 * statycznych gateway renderuje ciało błędu dwa razy, więc axios zostawia je jako string.
 */
export function isAccountBlockedResponse(status: unknown, data: unknown): boolean {
    if (status !== 403) {
        return false;
    }

    const text = typeof data === 'string' ? data : JSON.stringify(data ?? '');

    return text.includes(accountBlockedMarker);
}

let interceptorRegistered = false;

/**
 * Globalny interceptor odpowiedzi axiosa. Vendorowy Api.getData() woła `axios({...})`, czyli
 * domyślną instancję, więc jeden interceptor obejmuje wszystkie żądania aplikacji.
 * Rejestracja jest idempotentna, a błąd i tak leci dalej - interceptor tylko podnosi flagę.
 */
export function registerAccountBlockedInterceptor(): void {
    if (interceptorRegistered) {
        return;
    }
    interceptorRegistered = true;

    axios.interceptors.response.use(
        response => response,
        error => {
            if (isAccountBlockedResponse(error?.response?.status, error?.response?.data)) {
                accountBlocked.set(true);
            }

            return Promise.reject(error);
        }
    );
}
